import React from 'react';

/**
 * SaveToRead Logo Component
 * ONE universal logo - no customization, fully self-contained
 * - Fixed brand colors (#FF6F26 for icon, #111827 for text)
 * - Responsive sizing with clamp
 * - Works everywhere consistently
 */
export const Logo: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px'
      }}
    >
      <svg
        viewBox="0 0 428 428"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: 'clamp(32px, 8vw, 40px)',
          height: 'clamp(32px, 8vw, 40px)',
          flexShrink: 0
        }}
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M287.733653,427.174398 C277.886024,425.999159 264.814731,423.008481 255.109181,419.72261 C249.52969,417.835217 249.109212,417.90717 243.116923,421.768669 C231.266744,429.416023 234.567207,431.404888 176.187988,381.504291 C113.029913,327.518955 129.02727,326.753297 62.5245729,386.945074 C15.8764932,429.170643 9.17764771,432.838421 2.90887999,419.615602 C-2.01973462,409.23033 -0.211103936,18.2577562 4.7904703,11.8206953 C11.652515,2.99256806 8.98372871,3.29514128 91.8946617,1.96861599 C316.902143,-1.61244881 295.405933,-11.7523417 296.373608,98.4193658 C297.199204,192.670925 295.632492,184.237619 312.574485,185.457137 C408.040233,192.309313 460.277404,297.551291 406.181683,374.059882 C379.795259,411.370482 332.584622,432.543228 287.733653,427.174398 Z M330.962338,397.484582 C442.832394,372.747165 423.353652,213.835115 308.47092,214 C189.502186,214.165142 173.131053,374.001271 289.550153,398.68185 C296.55196,400.163308 322.199423,399.426246 330.962338,397.484582 Z M295.274524,337.677934 L295.274524,318.689202 L255.298246,318.689202 L255.298246,294.777465 L295.274524,294.777465 L295.274524,256.8 L320.444774,256.8 L320.444774,294.777465 L360.421053,294.777465 L360.421053,318.689202 L320.444774,318.689202 L320.444774,356.666667 L295.274524,356.666667 L295.274524,337.677934 Z M247.789474,178.333333 L247.789474,164.066667 L67.5789474,164.066667 L67.5789474,192.6 L247.789474,192.6 L247.789474,178.333333 Z M247.789474,128.4 L247.789474,114.133333 L67.5789474,114.133333 L67.5789474,142.666667 L247.789474,142.666667 L247.789474,128.4 Z M247.789474,78.4666667 L247.789474,64.2 L67.5789474,64.2 L67.5789474,92.7333333 L247.789474,92.7333333 L247.789474,78.4666667 Z"
            fill="#FF6F26"
          />
        </g>
      </svg>
      <span
        className="font-bold"
        style={{
          fontSize: 'clamp(16px, 4vw, 20px)',
          color: '#111827',
          whiteSpace: 'nowrap',
          lineHeight: 1
        }}
      >
        SaveToRead
      </span>
    </div>
  );
};

export default Logo;
